import Plot, { Figure, PlotParams } from "react-plotly.js";
import { FunctionComponent, memo, useEffect, useState } from "react";
import { PlotMouseEvent, PlotRelayoutEvent } from "plotly.js";

type TProps = {
  data: Figure["data"];
  layout: Figure["layout"];
  config?: PlotParams["config"];
  className?: string;
  onClick: (event: PlotMouseEvent) => void;
  onAfterPlot?: () => void;
  onRelayout?: (event: PlotRelayoutEvent) => void;
};

const PlotWrapper: FunctionComponent<TProps> = (props) => {
  const [figure, setFigure] = useState<Figure>({
    data: [],
    layout: {},
    frames: [],
  });

  useEffect(() => {
    setFigure({ ...figure, data: props.data, layout: props.layout });
  }, [props.data, props.layout]);

  return figure.data.length === 0 ? null : (
    <Plot
      className={props.className}
      data={figure.data}
      layout={figure.layout}
      onInitialized={(fig) => setFigure(fig)}
      config={props.config}
      onClick={props.onClick}
      onAfterPlot={props.onAfterPlot}
      onRelayout={props.onRelayout}
    />
  );
};

export default memo(PlotWrapper);
